export const SUPPORTED_COUNTRIES = [
  'BR',
  'AR',
  'CO',
  'IT',
  'EC',
  'BO',
  'MX',
  'PE',
  'PY',
  'UY',
  'CL',
] as const

export type Country = (typeof SUPPORTED_COUNTRIES)[number]
